/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import blocked from '../../../assets/images/blocked-icon.png';

const Blocked = () => (
  <div className="btn-component-div">
    <button type="button" className="btn btn-link">
      <img src={blocked} className="blocked-btn" alt="blocked" />
    </button>
  </div>
);

export default Blocked;
